// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + "shipbob_billing_ui_styles" + "." + "0fb25084" + ".chunk.css";
};